<template>
  <div class="default-actions">
    <el-link
      class="default-actions--link button-link"
      :href="offer.url"
      target="_blank"
      :underline="false">
      {{ $t('comparator.offers.offer.openQuotation') }}
    </el-link>
    <el-button
      type="success"
      :loading="optionsLoading"
      :disabled="disabledOffer || optionsLoading"
      @click="chooseOffer()">
      <font-awesome-icon :icon="['fas', 'arrow-right']" />
      {{ btnLabel }}
    </el-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MoveManager from '@/utils/components/MoveManager.vue';

export default {
  name: 'DefaultActions',
  extends: MoveManager,
  computed: {
    ...mapGetters({
      optionsLoading: 'offerStore/optionsLoading',
      comparatorConfig: 'configStore/comparatorConfig',
    }),
    btnLabel() {
      if (this.$helpers.offers.isFailureStatus(this.offer)) {
        return this.$t('comparator.offers.offer.refused');
      }
      return this.isInitialStatus
        ? this.$t('comparator.offers.offer.choose')
        : this.$t('comparator.offers.offer.choosen');
    },
    disabledOffer() {
      return this.optionsLoading
        || this.$helpers.offers.isFinishedState(this.offers)
        || this.$helpers.offers.isFailureStatus(this.offer);
    },
  },
  methods: {
    ...mapActions({
      postOptions: 'offerStore/postOptions',
    }),
    async chooseOffer() {
      this.$store.dispatch('actionsStore/track', 'openBook');
      const offerOptions = {
        id: this.offer.id,
        options: this.offer.options.reduce((acc, option) => {
          if (option.is_chosen) {
            acc.push(option.id);
          }
          return acc;
        }, []),
      };
      await this.postOptions(offerOptions);
      this.$router.push({
        name: 'booking',
        params: {
          id: this.offer.id,
        },
        hash: this.comparatorConfig && this.comparatorConfig.services ? '#services' : '#resume',
      });
    },
  },
};
</script>

<style scoped lang="scss">

.default-actions {
  justify-content: center;
  display: flex;
  flex-direction: row;
  @include breakpoint(tablet) {
    flex-direction: column;
  }
  &--link {
    margin-right: 20px;
    vertical-align: top;
    font-weight: 500;

    @include breakpoint(tablet) {
      margin-right: 0;
      margin-bottom: 20px;
    }

    :deep(.el-link--inner) {
      display: flex;
      align-items: center;

      svg {
        padding-right: 3px;
      }
    }
  }
}
</style>
